/* eslint func-names: ["error", "never"] */

$.fn.visible = function(partial) {

  const $t = $(this);
  const $w = $(window);
  const viewTop = $w.scrollTop();
  const viewBottom = viewTop + $w.height();
  const _top = $t.offset().top;
  const _bottom = _top + $t.height();
  const compareTop = partial === true ? _bottom : _top;
  const compareBottom = partial === true ? _top : _bottom;

  return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
};

const allMods = $('.animatedModule');
const windowScroll = _.debounce(() => {

  $('.animatedModule').each((i, el) => {
    if ($(el).visible(true)) {
      $(el).addClass('come-in');
    }
  });


  allMods.each((i, el) => {
    if ($(el).visible(true)) {
      $(el).addClass('come-in');
    }
  });

}, 300);

window.addEventListener('scroll', windowScroll);
